import _extends from "@babel/runtime/helpers/esm/extends";
var _IconClose;
import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useEffect } from 'react';
import Button from "../../atoms/Button";
import { IconClose } from "../../atoms/Icon";
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import { disableScrollBody } from "../../utils/disableScrollBody";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// define function
const PopupIdentity = ({
  isOpen,
  title,
  description,
  buttonProps,
  onClose = () => {}
}) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      disableScrollBody(isOpen);
    }
  }, [isOpen]);
  return /*#__PURE__*/_jsx(Modal, {
    open: isOpen,
    onClose: () => onClose?.(false),
    disableAutoFocus: true,
    disableEnforceFocus: true,
    sx: {
      pointerEvents: "auto",
      outline: 'none'
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: {
          md: "547px",
          xs: "100%"
        },
        outline: 'none',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          position: 'relative',
          backgroundColor: colors.neutral.white,
          borderRadius: '20px',
          minHeight: {
            xs: "324px",
            md: "365px"
          },
          maxHeight: '90%',
          maxWidth: {
            xs: "311px",
            md: "100%"
          },
          width: '100%',
          display: "flex",
          flexDirection: "column",
          padding: {
            xs: "30px 30px 72px 30px",
            md: "32px 32px 64px 32px"
          },
          outline: 'none',
          overflow: 'auto'
        },
        color: colors.secondaryGray.shade600,
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "16px",
            outline: 'none',
            "& svg": {
              cursor: "pointer",
              userSelect: "all"
            }
          },
          onClick: () => onClose?.(),
          children: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {}))
        }), /*#__PURE__*/_jsxs(Box, {
          children: [title && /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            color: colors.primary.bandaiNamcoBlack,
            sx: {
              textAlign: 'center'
            },
            children: title
          }), description && /*#__PURE__*/_jsx(Typography, {
            variant: "p8",
            color: colors.neutral.neutral2,
            sx: {
              textAlign: 'center',
              maxWidth: '400px',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: {
                xs: '8px'
              }
            },
            children: description
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              justifyContent: 'center'
            },
            children: /*#__PURE__*/_jsx(Button, _extends({}, buttonProps, {
              onClick: () => buttonProps.handler(),
              sx: {
                marginTop: '40px',
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: colors.primary.bandaiNamcoBlack,
                color: colors.primary.bandaiNamcoWhite,
                '&:hover': {
                  color: colors.primary.bandaiNamcoWhite,
                  backgroundColor: colors.primary.bandaiNamcoRed
                }
              }
            }))
          })]
        })]
      })
    })
  });
};
export default PopupIdentity;